import React from 'react'

function GroceryProducts() {
    return (
        <div>GroceryProducts</div>
    )
}

export default GroceryProducts